export default __webpack_public_path__ + "static/media/AtomsAndCompounds _04.d0272467.png";